import React from "react";
import { Link } from "react-router-dom";

const Success = () => {
  return (
    <div className="flex flex-col items-center min-h-screen py-6 ">
      <p className="text-base font-semibold text-[#212B36]">Order Sucess</p>
      <div className="flex flex-col items-center">
        <svg
          width="359"
          height="350"
          viewBox="0 0 359 373"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M359 285.271H0V285.457H359V285.271Z" fill="#EBEBEB" />
          <path
            d="M98.8397 290.351H75.0596V290.537H98.8397V290.351Z"
            fill="#EBEBEB"
          />
          <path
            d="M152.137 297.184H122.878V297.371H152.137V297.184Z"
            fill="#EBEBEB"
          />
          <path
            d="M74.342 294.849H37.6665V295.036H74.342V294.849Z"
            fill="#EBEBEB"
          />
          <path
            d="M323.028 291.604H256.154V291.79H323.028V291.604Z"
            fill="#EBEBEB"
          />
          <path
            d="M249.763 291.604H245.218V291.79H249.763V291.604Z"
            fill="#EBEBEB"
          />
          <path
            d="M229.358 294.752H199.037V294.939H229.358V294.752Z"
            fill="#EBEBEB"
          />
          <path
            d="M170.166 251.999H31.5272C30.4411 251.997 29.4001 251.547 28.6328 250.749C27.8655 249.95 27.4346 248.868 27.4346 247.739V45.2524C27.444 44.1304 27.8792 43.0576 28.6454 42.2671C29.4117 41.4765 30.4473 41.032 31.5272 41.03H170.166C171.253 41.03 172.296 41.4788 173.065 42.2777C173.834 43.0765 174.266 44.16 174.266 45.2897V247.739C174.266 248.869 173.834 249.952 173.065 250.751C172.296 251.55 171.253 251.999 170.166 251.999ZM31.5272 41.1792C30.4887 41.1812 29.4934 41.6112 28.7598 42.3749C28.0261 43.1385 27.6141 44.1734 27.6141 45.2524V247.739C27.6141 248.818 28.0261 249.853 28.7598 250.617C29.4934 251.38 30.4887 251.81 31.5272 251.812H170.166C171.204 251.808 172.199 251.378 172.934 250.615C173.668 249.852 174.082 248.818 174.086 247.739V45.2524C174.082 44.1733 173.668 43.1396 172.934 42.3766C172.199 41.6136 171.204 41.1832 170.166 41.1792H31.5272Z"
            fill="#EBEBEB"
          />
          <path
            d="M325.477 251.999H186.831C185.745 251.995 184.704 251.545 183.936 250.747C183.168 249.949 182.735 248.868 182.731 247.739V45.2524C182.742 44.1297 183.179 43.057 183.946 42.2666C184.714 41.4762 185.75 41.0319 186.831 41.03H325.477C326.555 41.0339 327.589 41.4793 328.354 42.2697C329.118 43.06 329.552 44.1317 329.562 45.2524V247.739C329.563 248.298 329.458 248.851 329.253 249.367C329.048 249.883 328.748 250.353 328.368 250.748C327.989 251.144 327.538 251.458 327.042 251.672C326.546 251.887 326.014 251.998 325.477 251.999ZM186.831 41.1792C185.792 41.1832 184.797 41.6136 184.063 42.3766C183.328 43.1396 182.914 44.1733 182.91 45.2524V247.739C182.914 248.818 183.328 249.852 184.063 250.615C184.797 251.378 185.792 251.808 186.831 251.812H325.477C326.515 251.808 327.51 251.378 328.244 250.615C328.979 249.852 329.393 248.818 329.397 247.739V45.2524C329.393 44.1733 328.979 43.1396 328.244 42.3766C327.51 41.6136 326.515 41.1832 325.477 41.1792H186.831Z"
            fill="#EBEBEB"
          />
          <path
            d="M50.7412 127.641H113.035C113.035 127.641 109.682 119.539 98.481 122.061C98.481 122.061 96.126 112.847 87.5818 114.123C87.5818 114.123 80.5095 106.156 70.1918 109.244C59.8742 112.333 60.7645 122.061 60.7645 122.061C60.7645 122.061 53.1322 119.987 50.7412 127.641Z"
            fill="#FAFAFA"
          />
          <path
            d="M217.475 78.2853H155.188C155.188 78.2853 158.534 70.1763 169.735 72.6978C169.735 72.6978 172.09 63.4847 180.642 64.7603C180.642 64.7603 187.714 56.8005 198.024 59.889C208.335 62.9774 207.459 72.6978 207.459 72.6978C207.459 72.6978 215.12 70.6314 217.475 78.2853Z"
            fill="#FAFAFA"
          />
          <path
            d="M263.413 76.1741H311.066C311.066 76.1741 309.243 69.378 302.35 71.616C302.35 71.616 303.786 62.4701 298.702 61.4107C293.619 60.3514 292.003 67.3116 292.003 67.3116C290.84 65.9418 289.332 64.9368 287.649 64.4095C285.965 63.8823 284.174 63.854 282.476 64.3276C280.806 64.7793 279.284 65.6906 278.071 66.9654C276.858 68.2402 275.998 69.8314 275.583 71.5713C275.583 71.5713 267.096 66.5209 263.413 76.1741Z"
            fill="#FAFAFA"
          />
          <path
            d="M90.9703 165.739H32.999V285.077H90.9703V165.739Z"
            fill="#E6E6E6"
          />
          <path
            d="M80.4301 165.739H32.999V285.077H80.4301V165.739Z"
            fill="#F0F0F0"
          />
          <path
            d="M91.6527 165.739H31.75V167.686H91.6527V165.739Z"
            fill="#E0E0E0"
          />
          <path
            d="M91.6527 161.845H31.75V163.792H91.6527V161.845Z"
            fill="#E0E0E0"
          />
          <path
            d="M90.3959 163.792H32.999V165.739H90.3959V163.792Z"
            fill="#F0F0F0"
          />
          <path
            d="M46.4114 172.759H37.501V182.158H46.4114V172.759Z"
            fill="#E6E6E6"
          />
          <path
            d="M46.4043 172.759H38.2837V182.158H46.4043V172.759Z"
            fill="#F5F5F5"
          />
          <path
            d="M59.9026 172.759H50.9922V182.158H59.9026V172.759Z"
            fill="#E6E6E6"
          />
          <path
            d="M59.8955 172.759H51.7749V182.158H59.8955V172.759Z"
            fill="#F5F5F5"
          />
          <path
            d="M73.3938 172.759H64.4834V182.158H73.3938V172.759Z"
            fill="#E6E6E6"
          />
          <path
            d="M73.3867 172.759H65.2661V182.158H73.3867V172.759Z"
            fill="#F5F5F5"
          />
          <path
            d="M46.4114 186.597H37.501V195.997H46.4114V186.597Z"
            fill="#E6E6E6"
          />
          <path
            d="M46.4043 186.597H38.2837V195.997H46.4043V186.597Z"
            fill="#F5F5F5"
          />
          <path
            d="M59.9026 186.597H50.9922V195.997H59.9026V186.597Z"
            fill="#E6E6E6"
          />
          <path
            d="M59.8955 186.597H51.7749V195.997H59.8955V186.597Z"
            fill="#F5F5F5"
          />
          <path
            d="M73.3938 186.597H64.4834V195.997H73.3938V186.597Z"
            fill="#E6E6E6"
          />
          <path
            d="M73.3867 186.597H65.2661V195.997H73.3867V186.597Z"
            fill="#F5F5F5"
          />
          <path
            d="M46.4114 211.939H37.501V221.338H46.4114V211.939Z"
            fill="#E6E6E6"
          />
          <path
            d="M46.4043 211.939H38.2837V221.338H46.4043V211.939Z"
            fill="#F5F5F5"
          />
          <path
            d="M59.9026 211.939H50.9922V221.338H59.9026V211.939Z"
            fill="#E6E6E6"
          />
          <path
            d="M59.8955 211.939H51.7749V221.338H59.8955V211.939Z"
            fill="#F5F5F5"
          />
          <path
            d="M73.3938 211.939H64.4834V221.338H73.3938V211.939Z"
            fill="#E6E6E6"
          />
          <path
            d="M73.3867 211.939H65.2661V221.338H73.3867V211.939Z"
            fill="#F5F5F5"
          />
          <path
            d="M46.4114 225.777H37.501V235.177H46.4114V225.777Z"
            fill="#E6E6E6"
          />
          <path
            d="M46.4043 225.777H38.2837V235.177H46.4043V225.777Z"
            fill="#F5F5F5"
          />
          <path
            d="M59.9026 225.777H50.9922V235.177H59.9026V225.777Z"
            fill="#E6E6E6"
          />
          <path
            d="M59.8955 225.777H51.7749V235.177H59.8955V225.777Z"
            fill="#F5F5F5"
          />
          <path
            d="M73.3938 225.777H64.4834V235.177H73.3938V225.777Z"
            fill="#E6E6E6"
          />
          <path
            d="M73.3867 225.777H65.2661V235.177H73.3867V225.777Z"
            fill="#F5F5F5"
          />
          <path
            d="M46.4114 253.938H37.501V263.338H46.4114V253.938Z"
            fill="#E6E6E6"
          />
          <path
            d="M46.4043 253.938H38.2837V263.338H46.4043V253.938Z"
            fill="#F5F5F5"
          />
          <path
            d="M59.9026 253.938H50.9922V263.338H59.9026V253.938Z"
            fill="#E6E6E6"
          />
          <path
            d="M59.8955 253.938H51.7749V263.338H59.8955V253.938Z"
            fill="#F5F5F5"
          />
          <path
            d="M73.3938 253.938H64.4834V263.338H73.3938V253.938Z"
            fill="#E6E6E6"
          />
          <path
            d="M73.3867 253.938H65.2661V263.338H73.3867V253.938Z"
            fill="#F5F5F5"
          />
          <path
            d="M46.4114 267.777H37.501V277.176H46.4114V267.777Z"
            fill="#E6E6E6"
          />
          <path
            d="M46.4043 267.777H38.2837V277.176H46.4043V267.777Z"
            fill="#F5F5F5"
          />
          <path
            d="M59.9026 267.777H50.9922V277.176H59.9026V267.777Z"
            fill="#E6E6E6"
          />
          <path
            d="M59.8955 267.777H51.7749V277.176H59.8955V267.777Z"
            fill="#F5F5F5"
          />
          <path
            d="M73.3938 267.777H64.4834V277.176H73.3938V267.777Z"
            fill="#E6E6E6"
          />
          <path
            d="M73.3867 267.777H65.2661V277.176H73.3867V267.777Z"
            fill="#F5F5F5"
          />
          <path
            d="M90.9703 202.606H32.999V203.479H90.9703V202.606Z"
            fill="#E0E0E0"
          />
          <path
            d="M90.9703 245.919H32.999V246.792H90.9703V245.919Z"
            fill="#E0E0E0"
          />
          <path
            d="M318.936 141.113H261.661V285.919H318.936V141.113Z"
            fill="#E0E0E0"
          />
          <path
            d="M302.623 141.113H261.661V285.919H302.623V141.113Z"
            fill="#F0F0F0"
          />
          <path
            d="M281.126 153.012H265.883V160.703H281.126V153.012Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.126 153.012H266.895V160.703H281.126V153.012Z"
            fill="#F5F5F5"
          />
          <path
            d="M298.76 153.012H283.517V160.703H298.76V153.012Z"
            fill="#E6E6E6"
          />
          <path
            d="M298.76 153.012H284.529V160.703H298.76V153.012Z"
            fill="#F5F5F5"
          />
          <path
            d="M281.126 167.484H265.883V175.176H281.126V167.484Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.126 167.484H266.895V175.176H281.126V167.484Z"
            fill="#F5F5F5"
          />
          <path
            d="M298.76 167.484H283.517V175.176H298.76V167.484Z"
            fill="#E6E6E6"
          />
          <path
            d="M298.76 167.484H284.529V175.176H298.76V167.484Z"
            fill="#F5F5F5"
          />
          <path
            d="M281.126 185.978H265.883V193.669H281.126V185.978Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.126 185.978H266.895V193.669H281.126V185.978Z"
            fill="#F5F5F5"
          />
          <path
            d="M298.76 185.978H283.517V193.669H298.76V185.978Z"
            fill="#E6E6E6"
          />
          <path
            d="M298.76 185.978H284.529V193.669H298.76V185.978Z"
            fill="#F5F5F5"
          />
          <path
            d="M281.126 196.608H265.883V204.3H281.126V196.608Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.126 196.608H266.895V204.3H281.126V196.608Z"
            fill="#F5F5F5"
          />
          <path
            d="M298.76 196.608H283.517V204.3H298.76V196.608Z"
            fill="#E6E6E6"
          />
          <path
            d="M298.76 196.608H284.529V204.3H298.76V196.608Z"
            fill="#F5F5F5"
          />
          <path
            d="M281.126 214.072H265.883V221.763H281.126V214.072Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.126 214.072H266.895V221.763H281.126V214.072Z"
            fill="#F5F5F5"
          />
          <path
            d="M298.76 214.072H283.517V221.763H298.76V214.072Z"
            fill="#E6E6E6"
          />
          <path
            d="M298.76 214.072H284.529V221.763H298.76V214.072Z"
            fill="#F5F5F5"
          />
          <path
            d="M281.126 224.695H265.883V232.387H281.126V224.695Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.126 224.695H266.895V232.387H281.126V224.695Z"
            fill="#F5F5F5"
          />
          <path
            d="M298.76 224.695H283.517V232.387H298.76V224.695Z"
            fill="#E6E6E6"
          />
          <path
            d="M298.76 224.695H284.529V232.387H298.76V224.695Z"
            fill="#F5F5F5"
          />
          <path
            d="M281.126 243.703H265.883V251.395H281.126V243.703Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.126 243.703H266.895V251.395H281.126V243.703Z"
            fill="#F5F5F5"
          />
          <path
            d="M298.76 243.703H283.517V251.395H298.76V243.703Z"
            fill="#E6E6E6"
          />
          <path
            d="M298.76 243.703H284.529V251.395H298.76V243.703Z"
            fill="#F5F5F5"
          />
          <path
            d="M281.126 257.736H265.883V265.427H281.126V257.736Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.126 257.736H266.895V265.427H281.126V257.736Z"
            fill="#F5F5F5"
          />
          <path
            d="M298.76 257.736H283.517V265.427H298.76V257.736Z"
            fill="#E6E6E6"
          />
          <path
            d="M298.76 257.736H284.529V265.427H298.76V257.736Z"
            fill="#F5F5F5"
          />
          <path
            opacity="0.05"
            d="M318.936 179.913H261.661V181.233H318.936V179.913Z"
            fill="black"
          />
          <path
            opacity="0.05"
            d="M318.936 208.522H261.661V209.842H318.936V208.522Z"
            fill="black"
          />
          <path
            opacity="0.05"
            d="M318.936 237.385H261.661V238.705H318.936V237.385Z"
            fill="black"
          />
          <path
            d="M318.935 136.831H258.961V141.457H318.935V136.831Z"
            fill="#E0E0E0"
          />
          <path
            opacity="0.05"
            d="M318.936 136.831H305.229V141.457H318.936V136.831Z"
            fill="black"
          />
          <path
            d="M180.089 108.603H115.339V283.45H180.089V108.603Z"
            fill="#E6E6E6"
          />
          <path
            d="M156.129 108.603H91.3726V283.45H156.129V108.603Z"
            fill="#F0F0F0"
          />
          <path
            d="M150.479 120.472H97.0234V129.379H150.479V120.472Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 120.472H99.0986V129.379H150.479V120.472Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 135.466H97.0234V144.373H150.479V135.466Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 135.466H99.0986V144.373H150.479V135.466Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 151.043H97.0234V159.95H150.479V151.043Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 151.043H99.0986V159.95H150.479V151.043Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 166.627H97.0234V175.534H150.479V166.627Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 166.627H99.0986V175.534H150.479V166.627Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 182.203H97.0234V191.11H150.479V182.203Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 182.203H99.0986V191.11H150.479V182.203Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 197.787H97.0234V206.694H150.479V197.787Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 197.787H99.0986V206.694H150.479V197.787Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 214.96H97.0234V223.867H150.479V214.96Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 214.96H99.0986V223.867H150.479V214.96Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 232.125H97.0234V241.033H150.479V232.125Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 232.125H99.0986V241.033H150.479V232.125Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 249.298H97.0234V258.205H150.479V249.298Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 249.298H99.0986V258.205H150.479V249.298Z"
            fill="#F5F5F5"
          />
          <path
            d="M150.479 266.471H97.0234V275.378H150.479V266.471Z"
            fill="#E6E6E6"
          />
          <path
            d="M150.479 266.471H99.0986V275.378H150.479V266.471Z"
            fill="#F5F5F5"
          />
          <path
            d="M181.776 106.842H89.542V111.109H181.776V106.842Z"
            fill="#F5F5F5"
          />
          <path
            d="M181.776 99.1434H89.542V103.411H181.776V99.1434Z"
            fill="#F5F5F5"
          />
          <path
            d="M178.71 102.575H91.3726V106.842H178.71V102.575Z"
            fill="#F0F0F0"
          />
          <path
            d="M180.096 120.472H162.053V129.379H180.096V120.472Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 135.13H162.053V144.038H180.096V135.13Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 149.789H162.053V158.697H180.096V149.789Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 166.619H162.053V175.526H180.096V166.619Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 182.203H162.053V191.11H180.096V182.203Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 197.787H162.053V206.694H180.096V197.787Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 214.953H162.053V223.86H180.096V214.953Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 232.125H162.053V241.033H180.096V232.125Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 249.298H162.053V258.205H180.096V249.298Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.096 266.471H162.053V275.378H180.096V266.471Z"
            fill="#E0E0E0"
          />
          <path
            d="M263.327 169.708H256.204V181.285H263.327V169.708Z"
            fill="#E0E0E0"
          />
          <path
            d="M263.327 188.656H256.204V200.234H263.327V188.656Z"
            fill="#E0E0E0"
          />
          <path
            d="M263.327 207.075H256.204V218.653H263.327V207.075Z"
            fill="#E0E0E0"
          />
          <path
            d="M263.327 226.545H256.204V238.123H263.327V226.545Z"
            fill="#E0E0E0"
          />
          <path
            d="M263.327 245.494H256.204V257.072H263.327V245.494Z"
            fill="#E0E0E0"
          />
          <path
            d="M263.327 158.07H188.375V276.505H263.327V158.07Z"
            fill="#E6E6E6"
          />
          <path
            d="M250.668 158.07H188.382V276.505H250.668V158.07Z"
            fill="#F0F0F0"
          />
          <path
            d="M244.63 169.715H193.982V181.293H244.63V169.715Z"
            fill="#EBEBEB"
          />
          <path
            d="M244.63 188.656H193.982V200.234H244.63V188.656Z"
            fill="#EBEBEB"
          />
          <path
            d="M244.63 207.604H193.982V219.182H244.63V207.604Z"
            fill="#EBEBEB"
          />
          <path
            d="M244.63 226.545H193.982V238.123H244.63V226.545Z"
            fill="#EBEBEB"
          />
          <path
            d="M244.63 245.494H193.982V257.072H244.63V245.494Z"
            fill="#EBEBEB"
          />
          <path
            d="M244.63 169.715H195.849V181.293H244.63V169.715Z"
            fill="#F5F5F5"
          />
          <path
            d="M244.63 188.656H195.849V200.234H244.63V188.656Z"
            fill="#F5F5F5"
          />
          <path
            d="M244.63 207.604H195.849V219.182H244.63V207.604Z"
            fill="#F5F5F5"
          />
          <path
            d="M244.63 226.545H195.849V238.123H244.63V226.545Z"
            fill="#F5F5F5"
          />
          <path
            d="M244.63 245.494H195.849V257.072H244.63V245.494Z"
            fill="#F5F5F5"
          />
          <path
            d="M179.5 318.96C256.385 318.96 318.713 315.179 318.713 310.515C318.713 305.851 256.385 302.07 179.5 302.07C102.615 302.07 40.2871 305.851 40.2871 310.515C40.2871 315.179 102.615 318.96 179.5 318.96Z"
            fill="#F5F5F5"
          />
          <path
            d="M100.326 310.515H97.4541"
            stroke="#19305C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M92.0258 310.515H18.6821"
            stroke="#19305C"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="7.57 7.57"
          />
          <path
            d="M15.9682 310.515H13.0962"
            stroke="#19305C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M271.229 131.946L188.383 133.373L189.375 195.514L272.221 194.086L271.229 131.946Z"
            fill="#3C61A8"
          />
          <path
            opacity="0.3"
            d="M238.389 132.504L188.301 133.367L189.293 195.508L239.381 194.645L238.389 132.504Z"
            fill="white"
          />
          <path
            opacity="0.3"
            d="M245.937 136.691L231.513 136.991L231.593 141.168L246.018 140.869L245.937 136.691Z"
            fill="white"
          />
          <path
            opacity="0.3"
            d="M246.365 185.013L231.943 185.261L232.01 189.438L246.432 189.19L246.365 185.013Z"
            fill="white"
          />
          <path
            d="M255.981 171.722C260.657 171.722 264.447 167.266 264.447 161.77C264.447 156.274 260.657 151.819 255.981 151.819C251.306 151.819 247.516 156.274 247.516 161.77C247.516 167.266 251.306 171.722 255.981 171.722Z"
            stroke="white"
            stroke-miterlimit="10"
          />
          <path
            d="M256.333 153.333V155.004"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M256.699 168.641V170.312"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M248.844 161.442H250.46"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M261.812 161.449H263.427"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M256.326 161.442L256.333 156.295"
            stroke="white"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M256.642 161.778L260.146 165.418"
            stroke="white"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M257.109 161.449C257.109 161.61 257.063 161.767 256.977 161.901C256.891 162.035 256.769 162.139 256.626 162.201C256.483 162.262 256.325 162.278 256.173 162.247C256.022 162.216 255.882 162.138 255.773 162.024C255.663 161.911 255.589 161.766 255.558 161.608C255.528 161.45 255.544 161.287 255.603 161.138C255.662 160.99 255.763 160.863 255.891 160.773C256.02 160.684 256.171 160.636 256.326 160.636C256.429 160.635 256.531 160.656 256.627 160.696C256.722 160.737 256.809 160.796 256.882 160.872C256.954 160.948 257.012 161.038 257.051 161.137C257.09 161.236 257.11 161.342 257.109 161.449Z"
            fill="white"
          />
          <path
            opacity="0.3"
            d="M255.981 174.355C262.171 174.355 267.189 168.721 267.189 161.77C267.189 154.82 262.171 149.185 255.981 149.185C249.791 149.185 244.773 154.82 244.773 161.77C244.773 168.721 249.791 174.355 255.981 174.355Z"
            fill="white"
          />
          <path
            d="M162.9 270.91C164.149 271.902 189.229 269.097 182.745 222.868C182.745 222.868 194.643 226.008 195.921 225.799C195.921 225.799 213.375 253.603 200.667 267.374C187.958 281.145 169.017 281.988 169.017 281.988L162.9 270.91Z"
            fill="#3C61A8"
          />
          <path
            opacity="0.3"
            d="M162.9 270.91C164.149 271.902 189.229 269.097 182.745 222.868C182.745 222.868 194.643 226.008 195.921 225.799C195.921 225.799 213.375 253.603 200.667 267.374C187.958 281.145 169.017 281.988 169.017 281.988L162.9 270.91Z"
            fill="black"
          />
          <path
            d="M190.694 230.022C190.758 230.022 183.686 230.163 181.317 227.105C178.947 224.046 177.346 218.578 181.654 214.848C185.962 211.118 211.257 195.004 223.169 193.736C235.081 192.468 247.832 200.45 247.832 200.45L232.237 212.431L198.656 220.876L190.694 230.022Z"
            fill="#263238"
          />
          <path
            d="M167.825 263.629L168.479 270.313L176.204 269.634L175.041 262.764L167.825 263.629Z"
            fill="#FFC3BD"
          />
          <path
            d="M166.325 269.828L177.533 269.664L178.33 275.543C178.33 275.543 167.833 275.692 163.517 275.095C159.202 274.498 159.877 272.163 159.877 272.163C159.877 272.163 164.932 272.29 166.325 269.828Z"
            fill="#263238"
          />
          <path
            d="M264.136 286.748C265.81 269.659 255.88 254.614 241.958 253.142C228.036 251.67 215.394 264.329 213.72 281.418C212.047 298.506 221.976 313.552 235.898 315.024C249.82 316.496 262.463 303.836 264.136 286.748Z"
            fill="#263238"
          />
          <path
            d="M221.316 188.954C221.316 188.954 222.48 216.683 206.956 217.474C191.433 218.265 174.754 216.497 174.754 216.497L179.644 266.322L165.09 267.255C165.09 267.255 154.643 224.986 152.999 214.363C151.355 203.74 152.783 196.228 163.575 191.513C174.366 186.798 221.316 188.954 221.316 188.954Z"
            fill="#3C61A8"
          />
          <path
            d="M134.445 276.93L153.781 218.578L179.629 188.932C179.629 188.932 157.07 189.022 146.228 195.497C135.386 201.972 134.984 209.753 132.995 219.011C131.006 228.269 123.029 272.089 123.029 272.089L134.445 276.93Z"
            fill="#3C61A8"
          />
          <path
            opacity="0.7"
            d="M221.316 188.954C221.316 188.954 197.292 187.843 179.672 188.954C179.672 188.954 157.113 189.044 146.271 195.519C135.429 201.994 134.984 209.753 132.995 219.011C131.006 228.269 123.029 272.089 123.029 272.089L134.445 276.93L153.781 218.578C157.034 234.751 165.09 267.225 165.09 267.225L179.644 266.322L174.747 216.526C174.747 216.526 191.419 218.295 206.949 217.504C222.479 216.713 221.316 188.954 221.316 188.954Z"
            fill="black"
          />
          <path
            d="M181.654 143.978L172.729 145.104C172.729 145.104 171.178 162.151 169.735 165.463C169.735 165.463 142.286 169.379 131.042 169.044L125.334 173.072L125.133 180.077L130.726 180.249L132.528 175.81C132.528 175.81 136.305 175.638 137.181 173.43C137.181 173.43 166.346 180.748 177.087 172.393C177.102 172.401 183.578 162.516 181.654 143.978Z"
            fill="#FFC3BD"
          />
          <path
            d="M207.229 98.3303C207.229 98.3303 210.022 102.06 208.96 105.291C208.666 106.212 208.15 107.039 207.459 107.692C206.769 108.346 205.928 108.803 205.018 109.021C205.018 109.021 204.494 114.19 201.557 114.34C198.62 114.489 199.604 102.948 199.604 102.948L207.229 98.3303Z"
            fill="#263238"
          />
          <path
            d="M184.619 189.081L182.659 155.757L170.496 147.357C170.496 147.357 174.474 132.788 182.085 130.319C189.695 127.85 206.296 122.187 216.362 125C226.428 127.812 225.272 140.151 223.542 149.305L221.603 149.782C221.603 149.782 221.302 185.851 221.287 188.954L184.619 189.081Z"
            fill="#263238"
          />
          <path
            d="M206.504 127.059C202.519 131.065 194.391 133.452 192.144 131.46C189.896 129.468 192.732 127.641 194.843 125.388C195.985 124.149 195.949 121.829 195.683 119.979C195.544 119.047 195.337 118.127 195.066 117.227C187.606 116.801 184.511 113.176 184.203 106.783C183.894 100.389 186.68 92.9666 186.68 92.9666L191.95 88.2966C191.95 88.2966 199.13 89.4156 204.874 93.5186C208.291 95.9357 207.279 100.695 205.865 104.209C205.265 105.704 204.545 107.144 203.711 108.513C202.907 117.264 206.504 127.059 206.504 127.059Z"
            fill="#FFC3BD"
          />
          <path
            d="M188.353 108.543C188.353 108.543 191.225 108.685 192.482 106.835"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M192.927 100.994C192.927 101.561 192.596 102.008 192.209 102.001C191.821 101.993 191.541 101.523 191.555 100.956C191.57 100.389 191.886 99.9417 192.273 99.9492C192.661 99.9566 192.948 100.427 192.927 100.994Z"
            fill="#263238"
          />
          <path
            d="M186.378 101.173C186.378 101.74 186.048 102.187 185.66 102.18C185.273 102.172 184.993 101.702 185.007 101.135C185.021 100.568 185.337 100.121 185.725 100.128C186.113 100.136 186.4 100.613 186.378 101.173Z"
            fill="#263238"
          />
          <path
            d="M188.654 105.805L188.36 101.232L186.256 105.574C186.585 105.864 186.991 106.042 187.42 106.083C187.849 106.124 188.28 106.027 188.654 105.805Z"
            fill="#ED847E"
          />
          <path
            d="M192.582 97.4128C193.133 97.2556 193.719 97.3065 194.237 97.5565C194.755 97.8065 195.171 98.2393 195.411 98.778"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M184.354 98.2558C184.354 98.2558 185.675 96.7638 187.226 97.1443"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M205.915 104.209C197.701 104.515 196.682 94.8391 196.682 94.8391C192.618 97.0771 186.708 92.9741 186.708 92.9741L191.979 88.2892C191.979 88.2892 199.159 89.4231 204.903 93.5112C208.342 95.9357 207.329 100.71 205.915 104.209Z"
            fill="#263238"
          />
          <path
            d="M184.066 95.8089C184.066 95.8089 179.816 92.8696 181.69 90.751C183.564 88.6323 195.044 92.6607 203.625 97.5993C203.625 97.5993 183.973 83.94 178.631 88.2593C174.215 91.8327 184.009 96.7936 183.714 96.7861L184.066 95.8089Z"
            fill="#3C61A8"
          />
          <path
            d="M208.04 94.8092C208.028 96.3561 207.746 97.8878 207.208 99.33L187.908 89.632C188.707 88.6727 189.665 87.8693 190.737 87.2597C191.879 86.5808 193.121 86.102 194.413 85.8423C195.783 85.5702 197.185 85.5198 198.57 85.6931C205.628 86.5361 208.076 92.1758 208.04 94.8092Z"
            fill="#3C61A8"
          />
          <path
            d="M122.57 193.565C122.57 193.565 100.771 224.897 118.721 273.126"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M151.34 209.842C151.34 209.842 151.34 209.902 151.34 210.021C151.34 210.141 151.34 210.208 151.34 210.342V210.417C151.081 213.434 150.601 216.427 149.904 219.369C148.913 223.718 147.599 227.858 146.515 231.185C141.92 245.322 142.451 260.555 142.451 260.555C140.929 258.586 138.143 257.183 134.661 256.199C121.981 252.581 100.455 254.52 100.455 254.52C96.2335 239.13 97.7413 215.042 101.942 201.554C106.142 188.067 117.788 191.11 117.788 191.11C117.788 191.11 130.08 191.483 131.624 191.312C134.449 190.956 137.309 191.016 140.118 191.491C149.61 193.296 151.893 201.092 151.34 209.842Z"
            fill="#3C61A8"
          />
          <path
            d="M245.979 268.56C224.439 288.762 182.86 290.88 151.921 288.642L134.589 256.244L127.567 243.121L150.126 211.528L151.318 209.865C151.318 209.865 151.318 209.924 151.318 210.044C151.318 210.163 151.318 210.23 151.318 210.365V210.439C151.01 216.071 149.014 261.272 164.96 272.357L165.09 272.454C167.247 273.903 169.751 274.699 172.32 274.752C201.578 275.632 200.76 235.96 193.321 227.463L244.091 216.862C244.091 216.862 254.114 243.084 245.979 268.56Z"
            fill="#3C61A8"
          />
          <path
            d="M189.509 218.862C189.509 218.862 184.749 222.965 187.204 228.47C189.66 233.976 213.332 223.285 222.652 221.338C231.971 219.391 242.756 217.489 247.394 216.497C252.032 215.505 251.63 201.681 247.839 200.458C244.048 199.234 206.913 206.053 200.753 209.798C196.685 212.364 192.913 215.405 189.509 218.862Z"
            fill="#263238"
          />
          <path
            d="M201.427 107.625C200.974 107.119 200.7 106.467 200.649 105.778C200.598 105.088 200.774 104.401 201.147 103.828C202.296 102.038 204.615 99.1956 206.841 101.322C209.957 104.306 204.637 109.729 202.433 108.416C202.063 108.203 201.725 107.937 201.427 107.625Z"
            fill="#FFC3BD"
          />
          <path
            opacity="0.2"
            d="M184.066 95.8089C184.066 95.8089 179.816 92.8696 181.69 90.751C182.523 89.811 185.014 90.005 188.382 91.0046C190.547 91.6103 192.668 92.3756 194.729 93.2948C197.687 94.6302 200.832 96.3385 203.625 97.5993C203.625 97.5993 183.973 83.94 178.631 88.2593C174.215 91.8327 183.399 96.4653 183.722 96.7787L183.88 96.1744L184.066 95.8089Z"
            fill="black"
          />
          <path
            d="M186.084 94.5332C186.084 94.5332 181.776 95.2792 184.749 100.098L186.084 94.5332Z"
            fill="#263238"
          />
          <path
            d="M190.213 91.594C190.213 91.594 183.715 89.2217 181.905 90.5645C180.096 91.9073 181.991 94.4661 184.059 95.7865L185.718 96.0103L186.694 92.9517L189.222 92.6309L190.213 91.594Z"
            fill="#263238"
          />
          <path
            opacity="0.3"
            d="M199.065 87.946L197.507 90.3406L190.736 87.282C191.879 86.6032 193.121 86.1243 194.412 85.8646L199.065 87.946Z"
            fill="white"
          />
          <path
            opacity="0.1"
            d="M197.558 116.57C197.11 117.808 196.467 118.96 195.655 119.979C195.515 119.047 195.309 118.127 195.038 117.227C195.908 117.163 196.761 116.941 197.558 116.57Z"
            fill="black"
          />
          <path
            d="M133.189 182.173C132.902 187.343 130.748 191.573 128.105 192.617C127.648 192.8 127.159 192.879 126.669 192.848C123.41 192.655 121.04 187.574 121.371 181.509C121.701 175.444 124.616 170.685 127.876 170.879C129.204 170.953 130.374 171.841 131.286 173.266C132.629 175.31 133.383 178.577 133.189 182.173Z"
            fill="#F5F5F5"
          />
          <path
            d="M133.189 182.173C132.902 187.343 130.748 191.573 128.105 192.617C125.09 192.438 122.9 187.746 123.209 182.173C123.517 176.601 126.203 172.177 129.218 172.356C129.995 172.416 130.731 172.744 131.308 173.288C132.629 175.31 133.383 178.578 133.189 182.173Z"
            fill="white"
          />
          <path
            d="M249.555 255.453C244.005 251.402 222.53 247.426 222.53 247.426C209.483 247.426 198.031 259.623 196.452 275.819C195.159 288.993 200.76 300.951 209.785 306.405C209.785 306.405 210.539 306.733 211.803 307.248C216.585 309.21 228.719 313.962 235.892 315.006"
            fill="#263238"
          />
          <path
            opacity="0.3"
            d="M264.136 286.748C265.81 269.659 255.88 254.614 241.958 253.142C228.036 251.67 215.394 264.329 213.72 281.418C212.047 298.506 221.976 313.552 235.898 315.024C249.82 316.496 262.463 303.836 264.136 286.748Z"
            fill="black"
          />
          <path
            d="M152.517 285.753C154.19 268.665 144.261 253.619 130.339 252.147C116.417 250.675 103.774 263.335 102.1 280.423C100.427 297.511 110.356 312.557 124.278 314.029C138.2 315.501 150.843 302.841 152.517 285.753Z"
            fill="#263238"
          />
          <path
            d="M142.796 257.847L129.958 313.85C128.085 314.165 126.18 314.223 124.293 314.021H124.149C121.686 313.365 122.785 314.073 120.315 313.223C114.033 311.067 104.907 307.255 104.907 307.255C95.2353 302.369 89.7714 290.485 91.0997 276.908C92.708 260.458 104.067 248.172 117.436 249.179C117.436 249.179 123.783 250.395 130.317 252.163C133.189 252.909 136.061 253.797 138.423 254.722C139.987 255.593 141.453 256.641 142.796 257.847Z"
            fill="#263238"
          />
          <path
            opacity="0.3"
            d="M152.518 285.718C151.082 300.452 141.482 311.888 129.944 313.82C128.071 314.135 126.166 314.193 124.279 313.992H124.135C121.506 313.697 118.951 312.905 116.596 311.657C106.896 306.546 100.757 294.133 102.1 280.407C103.773 263.331 116.388 250.686 130.303 252.133H130.339C133.164 252.43 135.906 253.299 138.409 254.692C139.973 255.566 141.44 256.616 142.782 257.825C149.653 264.032 153.652 274.446 152.518 285.718Z"
            fill="black"
          />
          <path
            d="M149.021 266.098C148.6 265.401 148.119 264.744 147.585 264.136C144.375 259.586 137.037 257.885 132.234 258.288C128.552 258.661 125.016 259.979 121.945 262.122C118.441 264.479 115.935 268.09 112.46 270.567C105.869 275.296 95.8673 275.162 89.2473 270.291C88.874 270.015 88.519 269.713 88.1847 269.388C87.51 268.658 87.06 267.736 86.8923 266.74C86.639 265.495 86.7311 264.202 87.1579 263.01C88.5939 258.817 93.383 255.132 96.4058 252.887C102.534 248.394 109.742 245.758 117.228 245.27C138.574 243.741 147.678 262.682 149.021 266.098Z"
            fill="#3C61A8"
          />
          <path
            opacity="0.3"
            d="M147.541 266.695C142.953 259.817 137.066 257.885 132.262 258.288C128.58 258.661 125.045 259.979 121.973 262.122C118.47 264.479 115.964 268.09 112.489 270.567C105.897 275.296 95.8956 275.162 89.2756 270.291C88.9023 270.015 88.5473 269.713 88.213 269.388C87.5383 268.658 87.0884 267.736 86.9206 266.74C86.6673 265.495 86.7594 264.202 87.1862 263.01C89.4049 265.673 95.8669 272.089 104.619 268.978C115.533 265.061 118.197 253.424 129.864 253.528C139.134 253.64 144.842 261.1 147.541 266.695Z"
            fill="black"
          />
          <g opacity="0.3">
            <path
              opacity="0.3"
              d="M99.5293 250.835C102.643 248.536 106.146 246.868 109.854 245.919C113.566 244.937 117.411 244.61 121.227 244.949C125.038 245.33 128.769 246.317 132.292 247.874L133.598 248.47L134.876 249.134C135.738 249.552 136.549 250.074 137.382 250.552C138.215 251.029 138.983 251.618 139.78 252.148C140.577 252.678 141.324 253.297 142.085 253.886C138.954 251.706 135.611 249.874 132.112 248.418C128.62 246.962 124.94 246.05 121.191 245.71C117.45 245.339 113.676 245.59 110.012 246.456C108.172 246.88 106.369 247.459 104.62 248.187C102.845 248.897 101.14 249.784 99.5293 250.835Z"
              fill="black"
            />
          </g>
          <g opacity="0.3">
            <path
              opacity="0.3"
              d="M122.778 245.501C121.882 242.39 121.345 239.18 121.177 235.938C120.94 232.707 120.889 229.462 120.954 226.239C121.019 223.017 121.234 219.764 121.521 216.541L122.045 211.722C122.275 210.118 122.476 208.515 122.763 206.918L122.11 216.616L121.852 221.45C121.808 223.062 121.715 224.673 121.708 226.284C121.586 229.507 121.643 232.73 121.758 235.982C121.808 237.594 121.931 239.198 122.088 240.801C122.215 242.383 122.445 243.953 122.778 245.501Z"
              fill="black"
            />
          </g>
          <path
            opacity="0.3"
            d="M164.924 272.29C149.933 262.271 149.337 236.422 149.846 219.369C149.94 216.437 150.055 213.774 150.141 211.484C150.298 209.191 150.298 206.89 150.141 204.598C148.626 192.886 140.01 191.476 140.01 191.476H140.046C149.588 193.296 151.871 201.092 151.318 209.842C151.318 209.842 151.318 209.902 151.318 210.022C151.318 210.141 151.318 210.208 151.318 210.342V210.417C150.995 216.049 148.999 261.249 164.924 272.29Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M163.704 184.008C162.448 185.374 146.199 181.875 143.363 183.441C142.164 184.098 141.64 186.425 140.434 188.977C137.045 194.572 132.277 195.452 131.983 195.497C137.669 191.021 139.256 180.249 136.434 173.438C133.613 166.627 123.51 168.395 122.936 168.596C124.659 167.809 126.512 167.376 128.393 167.32C133.857 167.022 140.52 168.618 142.387 172.214C146.178 179.547 162.433 177.899 163.927 179.823C165.42 181.748 164.961 182.643 163.704 184.008Z"
            fill="black"
          />
          <path
            d="M150.981 177.496C149.993 179.39 149.599 181.557 149.854 183.695L163.618 185.306C164.321 184.46 164.841 183.467 165.142 182.393C165.444 181.32 165.519 180.191 165.362 179.085C165.362 179.085 151.728 177.66 150.981 177.496Z"
            fill="#263238"
          />
          <path
            d="M109.186 176.966C109.186 176.966 107.815 173.937 109.459 172.02C105.783 171.677 103.507 171.274 101.137 170.916C100.786 172.028 100.613 173.094 101.855 174.788C103.098 176.481 109.186 176.966 109.186 176.966Z"
            fill="#263238"
          />
          <path
            d="M101.539 195.922C99.1556 199.958 97.1165 206.418 96.937 216.736"
            stroke="#3C61A8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M109.387 189.268C107.653 189.686 106.059 190.58 104.771 191.856"
            stroke="#3C61A8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M216.462 150.379L207.401 151.528C207.401 151.528 205.822 168.827 204.357 172.192C204.357 172.192 176.491 176.175 165.068 175.825L159.274 179.913L159.073 187.03L164.752 187.201L166.583 182.725C166.583 182.725 170.417 182.554 171.3 180.308C171.3 180.308 200.911 187.768 211.817 179.264C211.81 179.234 218.394 169.2 216.462 150.379Z"
            fill="#FFC3BD"
          />
          <path
            opacity="0.2"
            d="M142.681 283.48C142.422 292.865 136.506 300.295 129.462 300.086C128.516 300.057 127.578 299.888 126.677 299.586C121.033 297.721 116.969 290.806 117.192 282.712C117.414 274.879 121.572 268.403 127.036 266.606C128.127 266.241 129.271 266.072 130.417 266.106C137.461 266.322 142.946 274.125 142.681 283.48Z"
            fill="#FAFAFA"
          />
          <path
            d="M136.197 283.48C135.975 291.492 131.889 298.079 126.677 299.609C121.033 297.744 116.969 290.828 117.192 282.734C117.414 274.901 121.572 268.426 127.036 266.628C132.464 268.157 136.42 275.185 136.197 283.48Z"
            fill="#263238"
          />
          <path
            opacity="0.2"
            d="M253.31 284.226C253.045 293.611 247.128 301.048 240.092 300.832C239.145 300.807 238.206 300.638 237.306 300.332C231.655 298.467 227.592 291.559 227.821 283.458C228.037 275.632 232.194 269.149 237.658 267.352C238.75 266.987 239.893 266.818 241.04 266.852C248.083 267.068 253.569 274.856 253.31 284.226Z"
            fill="#FAFAFA"
          />
          <path
            d="M246.827 284.226C246.597 292.231 242.519 298.818 237.306 300.347C231.655 298.482 227.592 291.574 227.821 283.473C228.037 275.647 232.194 269.164 237.658 267.366C243.093 268.896 247.056 275.923 246.827 284.226Z"
            fill="#263238"
          />
          <path
            d="M264.41 259.504C264.532 268.732 251.013 274.841 228.388 278.691C222.29 279.805 216.058 279.88 209.936 278.915C199.884 277.191 194.973 272.775 194.973 272.775C194.973 272.775 197.529 240.884 222.824 236.84C240.056 234.095 253.023 241.316 259.6 249.097C262.694 252.752 264.375 256.549 264.41 259.504Z"
            fill="#3C61A8"
          />
          <path
            opacity="0.3"
            d="M264.411 259.504C264.533 268.732 251.013 274.841 228.389 278.691C222.29 279.805 216.058 279.881 209.936 278.915C211.02 270.254 215.888 247.538 237.048 245.181C246.647 244.106 254.057 246.12 259.6 249.097C262.695 252.752 264.375 256.55 264.411 259.504Z"
            fill="black"
          />
          <g opacity="0.3">
            <path
              opacity="0.3"
              d="M196.438 272.917C196.903 268.576 197.899 264.314 199.403 260.235C200.881 256.113 202.922 252.234 205.463 248.716C206.747 246.968 208.189 245.352 209.771 243.89C211.338 242.404 213.065 241.113 214.919 240.04C218.607 237.88 222.693 236.555 226.909 236.154C224.843 236.513 222.811 237.058 220.835 237.78C219.837 238.093 218.897 238.578 217.963 238.989C217.027 239.455 216.114 239.97 215.228 240.533C214.323 241.07 213.49 241.719 212.636 242.323C211.781 242.927 210.991 243.644 210.237 244.397C208.704 245.845 207.307 247.441 206.066 249.164C203.544 252.614 201.488 256.407 199.956 260.436C199.16 262.443 198.475 264.496 197.902 266.583C197.293 268.662 196.804 270.777 196.438 272.917Z"
              fill="black"
            />
          </g>
          <path
            d="M162.491 262.383L163.984 267.65L179.644 266.292L179.852 258.929L162.491 262.383Z"
            fill="#3C61A8"
          />
          <path
            d="M255.703 226.662L290.16 225.208"
            stroke="#19305C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M301.567 218.489L306.687 218.272"
            stroke="#19305C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M272.237 219.727L297.64 218.653"
            stroke="#19305C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M290.015 238.258L311.303 237.362"
            stroke="#19305C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M276.854 238.817L286.13 238.422"
            stroke="#19305C"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div className="w-[60%] xs:w-full px-10">
          <p className="text-sm text-gray-600 mb-2 text-center">
            Your order has been successfully placed and is being processed. We
            appreciate your trust in us and will notify you when your items are
            on the way!
          </p>
          <p className="text-xs text-gray-500 text-center">
            If you have any questions or need support, feel free to reach out to
            our customer service team.
          </p>
        </div>
      </div>
      <Link
        to={"/dashboard/my-orders"}
        className={`w-[40%] xs:w-[80%] xs:mt-[16%] mt-[12%] px-5 flex justify-center items-center py-[10px] rounded-full bg-[#212730] hover:shadow-[#212730]/20 hover:shadow-lg text-sm text-white`}
      >
        Check Your Order
      </Link>
    </div>
  );
};

export default Success;
